import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.primary.main,
    width: 400,
    marginBottom: 32,
    padding: 32,
  },
  text: {
    color: colors.white,
    fontSize: 20,
  },
}));

export default useStyles;
